export type LabelParams = {
	name: string,
	baseColor: string,
	hoverColor: string
};

type LabelGroupParams = {
	id: number,
	name: string,
	labels: LabelParams[],
	groupType: string
};

export type LabelGroupJSON = {
	id: number,
	name: string,
	labels: Array<{
		name: string,
		base_color: string,
		hover_color: string
	}>,
	group_type: string
};

export type LabelGroupsResponse = {
	workspace_label_groups: LabelGroupJSON[],
	project_label_groups: LabelGroupJSON[]
};

export default class LabelGroup {
	id: number;
	name: string;
	labels: LabelParams[];
	groupType: string;

	constructor( { id, name, labels, groupType }: LabelGroupParams ) {
		this.id = id;
		this.name = name;
		this.labels = labels;
		this.groupType = groupType;
	}

	static fromJSON( json: LabelGroupJSON ) {
		return new LabelGroup( {
			id: json.id,
			name: json.name,
			labels: json.labels.map(
				( { name, base_color, hover_color } ) => ( {
					name,
					baseColor: base_color,
					hoverColor: hover_color
				} )
			),
			groupType: json.group_type
		} );
	}

	toJSON(): LabelGroupJSON {
		return {
			id: this.id,
			name: this.name,
			labels: this.labels.map(
				( { name, baseColor, hoverColor } ) => ( {
					name,
					base_color: baseColor,
					hover_color: hoverColor
				} )
			),
			group_type: this.groupType
		};
	}
}
